import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Cactus from '../graphs/Cactus';
import MyScatter from '../graphs/MyScatter';
import Benchmarks from './Benchmarks';
import Footer from '../miscellaneous/Footer';
import axios from 'axios';
import {useStyles, urlapi, NEED_LOGIN} from "../miscellaneous/constants";
import MyAppBar from '../miscellaneous/MyAppBar';
import LateralBar from "../miscellaneous/LateralBar";
import Summary from "./Summary";
import {Redirect} from "react-router-dom";
import {useCookies} from "react-cookie";
import {cleanJSON, isFiltered, nbInFamily} from "../miscellaneous/functions";
import Load from "../miscellaneous/Load"
import Graphs from "../graphs/Graphs";
import {createGraphsData, createCactusData, forFamily} from "../graphs/createDataSATCSP";
import Title from "../miscellaneous/Title";
import MyRadar from "../graphs/MyRadar";








export default function Analysis(props) {

    let nof = {
        forbidfamilies: [],
        optim: false,
        timeLimit: 2000,
        name: "",
        selection: "ALL",
        formula: "d > 0 && c > 0 && v > 0",
        constraints: {willing: false, types: []}
    }

    const [solvers, setSolvers] = useState([]);
    const [initialSolvers, setInitialSolvers] = useState([]);

    const [cookies, setCookie, removeCookie] = useCookies(['analyzer']);

    const [selectedSolvers, setSelectedSolvers] = useState([]);
    const [competition, setCompetition] = useState(null)

    const [benchmarks, setBenchmarks] = useState([])
    const [results, setResults] = useState([]);
    const [allresults, setAllresults] = useState(null)

    const [graphSolvers, setGraphSolvers] = useState(null)
    const [maxSolved, setMaxSolved] = useState(null)


    const [filters, setFilters] = useState(nof)
    const [nofilters, setNoFilters] = useState(nof)

    const classes = useStyles();

    const [graph, setGraph] = useState(0)                    // Display graph or table data
    const [displayLateralBar, setDisplayLateralBar] = useState(true); // display Lateral Bar


    function toggleGraphs(e, nb) {
        e.preventDefault()
        setGraph(nb)
    }


    function toggleFilters(e) {
        e.preventDefault()
        setDisplayLateralBar(!displayLateralBar)
    }

    async function selectGraphSolvers(e) {
        e.preventDefault();
        const s1 = e.target.elements[0].value
        const s2 = e.target.elements[1].value

        const solver1 = (await axios.get(urlapi + "/solver/" + s1)).data
        const solver2 = (await axios.get(urlapi + "/solver/" + s2)).data

        if (solver1.id === solver2.id)
            return
        setGraphSolvers({solver1: solver1, solver2: solver2})
    }

    function unselectGraphSolvers(e) {
        e.preventDefault()
        setGraphSolvers(null)
    }



    let st = open ? {paddingLeft: '240px'} : {paddingLeft: 0}


    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);


    async function selectCompetition(id) {

        setBenchmarks([])

        let c = (await axios.get(urlapi + "/competitions/" + id)).data;
        cleanJSON(c, ["defaulttime"])
        c.rank = c.rank !== null ? JSON.parse(c.rank) : null
        setCompetition(c);
        setFilters(({...filters, timeLimit: c.defaulttime}))
        setNoFilters(({...filters, timeLimit: c.defaulttime}))

        let s = (await axios.get(urlapi + "/solversincompetition/" + c.id)).data;
        cleanJSON(s, ['id'])
        setSolvers(s);
        let b = (await axios.get(urlapi + "/benchmarksincompetition/" + c.id, {responseType: "json"})).data;
        cleanJSON(b, ['competition_id', 'nb_clauses', 'nb_variables'])
        setBenchmarks(b);
        setSelectedSolvers([]);

        let tmp = {}
        for (let i = 0; i < s.length; i++) {
            let t = (await axios.get(urlapi + "/solverresultincompetition/" + c.id + "/" + s[i].id)).data;
            cleanJSON(t, ['benchmark_id', 'id', 'nb_clauses', 'nb_variables', 'time', 'solver_id'])
            tmp[s[i].id] = t
        }
        setAllresults(tmp)

        let max = (await axios.get(urlapi + "/competitions/maxsolved/"+c.id+"/"+c.defaulttime)).data
        setMaxSolved(max + (10 - max % 10))

        let initS = (await axios.get(urlapi + "/displaysolvers/"+c.id)).data
        setInitialSolvers(initS)

    }


    useEffect(() => {
        selectCompetition(props.match.params.id)
    }, [props.match.params.id])

    useEffect(() => {
        if (benchmarks.length === 0 || competition == null || allresults == null || solvers.length === 0)
            return
        //if(competition.rank != null)

        solversSelectionUpdate(null, initialSolvers.map(s => s.id))

    }, [benchmarks, competition, allresults, solvers, initialSolvers])



    async function solversSelectionUpdate(e, ids) {
        let tmp = selectedSolvers.map(s => s)
        let tmp2 = results.map(s => s)

        if (ids.length === 0) { // unselect all
            setSelectedSolvers([])
            setResults([])
            return
        }
        let selectedSolversId = selectedSolvers.map(s => s.id)
        for (let i = 0; i < ids.length; i++) {
            let id = ids[i];
            if (solvers.length === ids.length && selectedSolversId.indexOf(id) !== -1)
                continue
            if (tmp.filter(s => s.id === id).length === 0) {
                tmp.push(solvers.filter(s => s.id === id)[0]);
                tmp2[id] = allresults[id]
            } else {
                tmp = tmp.filter(s => s.id !== id);
                tmp2[id] = undefined;
            }
        }
        setSelectedSolvers(tmp);
        setResults(tmp2);
    }

    if (NEED_LOGIN && !cookies.analyzer)
        return <Redirect to={"/login"}/>

    if (competition === null || benchmarks.length === 0 || allresults == null || maxSolved == null)
        return (
            <Load>
            </Load>
        )

    let constraints = {}
    if (competition.type === "csp") {
        for (let b of benchmarks) {
            let tmp = b.info_constraints.split("#").map(e => e.split(":")[0])
            for (let i = 1; i < tmp.length; i++) constraints[tmp[i]] = 1
        }
    }
    let families = {}
    for (let b of benchmarks) {
        families[b.family] = 1
    }

    function createData(type) {
        if (solvers == null)
            return null

        return createGraphsData(allresults, benchmarks, filters, graphSolvers, type)
    }


    let main = null
    const sat1 = graphSolvers == null ? null : graphSolvers.solver1.name + " " + graphSolvers.solver1.version + " #SAT"
    const sat2 = graphSolvers == null ? null : graphSolvers.solver2.name + " " + graphSolvers.solver2.version  + " #SAT"
    const unsat1 = graphSolvers == null ? null : graphSolvers.solver1.name + " " + graphSolvers.solver1.version  + " #UNSAT"
    const unsat2 = graphSolvers == null ? null : graphSolvers.solver2.name + " " + graphSolvers.solver2.version  + " #UNSAT"

    let padstyle = displayLateralBar ? {paddingLeft: '240px'} : {paddingLeft: 0}

    if(graph === 0) {
        main = <Grid container spacing={3}>
            {/* Cactus */}

            <Grid item xs={12}>
                {/* Summary */}
                <Paper className={classes.paper}>
                    <Summary results={results} selectedSolvers={selectedSolvers} competition={props.match.params.id}
                             benchmarks={benchmarks} filters={filters}/>
                </Paper>
            </Grid>{/* All results */}
            <Grid item xs={12}>
                <Paper className={fixedHeightPaper}>
                    <Cactus data={createCactusData(selectedSolvers, results, benchmarks, filters)} maxX={maxSolved} selectedSolvers={selectedSolvers}/>
                </Paper>
            </Grid><Grid item xs={12}>
            <Benchmarks results={results} selectedSolvers={selectedSolvers} competition={competition} benchmarks={benchmarks}
                        filters={filters} />
        </Grid>
        </Grid>

    }
    if(graph === 1) {
        main = <Grid item xs={12} style={{minHeight: "80vh"}}>
            <Graphs solvers={solvers}
                    selectGraphSolvers={selectGraphSolvers}
                    unselectGraphSolvers={unselectGraphSolvers}
                    filters={filters}
                    graphSolvers={graphSolvers}
                    createData={createData}
                    category1_solver1={sat1}
                    category1_solver2={sat2}
                    category2_solver1={unsat1}
                    category2_solver2={unsat2}
            />
        </Grid>
    }
    if(graph===2) {
        const _families = []
        for (let f in families) {
            if (filters.forbidfamilies.includes(f) === false)
                _families.push(f);
        }
        main = <React.Fragment>
            <Title><span style={{color: '#408033'}}>Radar</span></Title>
            <Grid container>
                {_families.map(f => <MyRadar data={forFamily(f, results, filters, selectedSolvers)}  family={f} nb={nbInFamily(benchmarks, f, filters)}/>)}
            </Grid>
        </React.Fragment>

    }

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <MyAppBar toggleFilters={toggleFilters} active={"home"} competition={competition} toggleGraph={toggleGraphs} graph={graph}/>
            <LateralBar selectedSolvers={selectedSolvers} solvers={solvers} displayLateralBar={displayLateralBar}
                        solversSelectionUpdate={solversSelectionUpdate}
                        filters={filters} setFilters={setFilters} nofilters={nofilters}
                        constraints={constraints}
                        rank={competition.rank}
                        families={families}
            />

            <main className={classes.content} style={padstyle}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth="lg" className={classes.container}>
                    {main}
                    <Box pt={4}>
                        <Footer/>
                    </Box>
                </Container>
            </main>
        </div>
    );
}
